import { formatLargeNumber } from "@/lib/utils";

interface NeighborhoodStatsProps {
  medianPropertyPrice: number | null;
  medianPropertyPricePerSqft: number | null;
  medianSoldPropertyPrice: number | null;
}

export function NeighborhoodStats({
  medianPropertyPrice,
  medianPropertyPricePerSqft,
  medianSoldPropertyPrice,
}: NeighborhoodStatsProps) {
  const hasStats =
    medianPropertyPrice ||
    medianPropertyPricePerSqft ||
    medianSoldPropertyPrice;
  if (!hasStats) return null;

  return (
    <div className="flex flex-col gap-4">
      {medianPropertyPrice && (
        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="text-sm text-gray-600">Median Property Price</div>
          <div className="text-xl font-semibold">
            {formatLargeNumber(medianPropertyPrice)}
          </div>
        </div>
      )}
      {medianPropertyPricePerSqft && (
        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="text-sm text-gray-600">
            Median Property Price/SQ FT
          </div>
          <div className="text-xl font-semibold">
            {formatLargeNumber(medianPropertyPricePerSqft)}
          </div>
        </div>
      )}
      {medianSoldPropertyPrice && (
        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="text-sm text-gray-600">
            Median Sold Property Price
          </div>
          <div className="text-xl font-semibold">
            {formatLargeNumber(medianSoldPropertyPrice)}
          </div>
        </div>
      )}
    </div>
  );
}
